import { DEFAULT_COLUMN_STYLE } from '~/components/MultiGrid/constants';
import { IBaseFieldData, IColumnStyle } from '~/components/MultiGrid/types';

export const INVOICE_FIELDS_ORDER = ['client_name', 'email', 'phone', 'actions'];

export const INVOICE_ALL_FIELDS: Record<IBaseFieldData['value'], IBaseFieldData & IColumnStyle> =
  Object.freeze({
    client_name: {
      label: 'Client Name',
      value: 'client_name',
      ...DEFAULT_COLUMN_STYLE,
      width: 250,
      isStatic: true,
    },
    email: {
      label: 'Email',
      value: 'email',
      ...DEFAULT_COLUMN_STYLE,
      width: 286,
    },
    phone: {
      label: 'Phone',
      value: 'phone',
      ...DEFAULT_COLUMN_STYLE,
      isCellFullWidth: true,
      width: 230,
    },
    // total_billed: {
    //   label: 'Total Billed',
    //   value: 'total_billed',
    //   ...DEFAULT_COLUMN_STYLE,
    //   isCellFullWidth: true,
    //   width: 230,
    // },
    actions: {
      label: '',
      value: 'actions',
      ...DEFAULT_COLUMN_STYLE,
      width: 95,
      isCellFullWidth: true,
      maxWidth: '100%',
    },
  });

export const CLIENT_FILTER_OPTIONS: Record<
  string,
  Array<{
    id: string;
    name: string;
    dataProps: { 'data-name': string };
  }>
> = Object.freeze({});

export interface IListClient {
  id: number;
  business_client_uuid: string;
  company_name: string;
  email: string;
  country_code: string;
  phone: string;
  currency: string;
  total_billed: number;
}
